import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import axios from 'src/app/Service/axios';
import { DataService } from 'src/app/Service/data.service';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { DomSanitizer } from '@angular/platform-browser';
import { SignalrService } from 'src/app/Service/signalr.service';

declare let $: any;

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ["./login.component.css"]
})

export class LoginComponent implements OnInit {

  constructor(
    private el: ElementRef,
    private router: Router,
    private notifyService: NotificationService,
    private otherService: OtherService,
    private dataService: DataService,
    private deviceService: DeviceDetectorService,
    private gurdService: GurdServiceService,
    private sanitizer: DomSanitizer,
    private _signalRService: SignalrService,
  ) {
    this.dataService.carData = null;

  }

  password: boolean = false;
  appName: string = `${(<any>window).appName}`;
  timer: number = 0;
  otp: boolean = false;
  repet: boolean = true;
  timeLeft: number = 120;
  interval: any;
  isDesktop: any;
  isTablet: any;
  isMobile: any;
  version: string = `${(<any>window).version}`;
  webAppName = (<any>window).webAppName;
  captcha!: number | String;
  timesLoginBtnClicked: number = 0;
  obj_Social: { strTM: string, strWA: string, strIG: string, strEmail: string } | any = {};
  lst_NewAds: any = [];
  news: any = [];
  lst_Educations: any = [];
  isLandingWithLogin: boolean = (<any>window).isLandingMode;

  LoginModel = new FormGroup({

    strUserName: new FormControl(''),

    strPassword: new FormControl(''),

    strCaptcha: new FormControl(''),

    strSessionID: new FormControl(''),

  });

  RegisterModel = new FormGroup({
    strUserName: new FormControl(),
    strIntroducedMobile: new FormControl(),
    strFullName: new FormControl(),
    strPassword: new FormControl(),
    strPassword2: new FormControl(),
  });

  OtpModel = new FormGroup({
    strUserName: new FormControl(),
    iOTP: new FormControl(),
  });

  carouselOptions4News: OwlOptions = {
    items: 1,
    rtl: true,
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000, // Adjust the autoplay timeout as needed
    autoplayHoverPause: true,
    dots: false,
    margin: 20,
    nav: false, // Set to true if you want navigation arrows
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
  };

  @ViewChild("_captcha") _captcha!: ElementRef;
  @ViewChild('adsContainer') adsContainer!: ElementRef;
  @ViewChild('EventContainer') EventContainer!: ElementRef;
  @ViewChild('EducationContainer') EducationContainer!: ElementRef;

  ngOnInit(): void {
    this.otherService.setTitle(`${this.webAppName} | ورود به سامانه مدیریت ناوگان`)
    
    this._signalRService.disconnect();
    this.otherService.removeLocalStorage();
    
    this.isDesktop = this.deviceService.isDesktop();
    this.isTablet = this.deviceService.isTablet();
    this.isMobile = this.deviceService.isMobile();
    this.get_Captcha();
    
    setTimeout(() => {
      this.otherService.nonespinner();
    }, 500);

  }

  ngAfterViewInit() {

    const threshold = 0.5;

    const observer_1 = new IntersectionObserver((entries) => {

      entries.forEach((entry) => {

        if (entry.isIntersecting) {

          // this.getDrivers()

          observer_1.disconnect();

        }

      });

    }, { threshold });

    const observer_2 = new IntersectionObserver((entries) => {

      entries.forEach((entry) => {

        if (entry.isIntersecting) {

          this.getEvents();

          observer_2.disconnect();

        }

      });

    }, { threshold });

    const observer_3 = new IntersectionObserver((entries) => {

      entries.forEach((entry) => {

        if (entry.isIntersecting) {

          // this.getFeedback();

          observer_3.disconnect();

        }

      });

    }, { threshold });

    const observer_4 = new IntersectionObserver((entries) => {

      entries.forEach((entry) => {

        if (entry.isIntersecting) {

          this.getAds();

          observer_4.disconnect();

        }

      });

    }, { threshold });

    const observer_5 = new IntersectionObserver((entries) => {

      entries.forEach((entry) => {

        if (entry.isIntersecting) {

          this.getEducations();

          observer_5.disconnect();

        }

      });

    }, { threshold });

    // observer_1.observe(this.fleetContainer.nativeElement);

    observer_2.observe(this.EventContainer.nativeElement);

    // observer_3.observe(this.feedbackContainer.nativeElement);

    // observer_4.observe(this.adsContainer.nativeElement);

    observer_5.observe(this.EducationContainer.nativeElement);

  }

  ngOnDestroy() {
    this.otherService.setTitle('')
  }

  get_Captcha = async () => {

    this.otherService.Showspinner();

    this.captcha = 'XXXX';

    const resp = await axios.post('Captcha_Get', {});

    let res = JSON.parse(resp.data);

    this.otherService.nonespinner();

    if (res?.bError) {
      return this.notifyService.showError('خطا در دریافت کد امنیتی!');
    }

    this.captcha = res.strCaptcha;

    this.LoginModel.controls['strSessionID'].setValue(res.strSessionID);

    this.LoginModel.controls['strCaptcha'].setValue('');

  }

  changeType() {

    this.password = !this.password;
  }

  Login = async () => {

    // this.timesLoginBtnClicked++;

    var model = this.LoginModel.value;

    if (!model.strUserName) return this.notifyService.showError('نام کاربری نمی تواند خالی باشد');

    if (!model.strPassword) return this.notifyService.showError('رمز عبور نمی تواند خالی باشد');

    if (!model.strCaptcha || model.strCaptcha.trim() == '') {

      return this.notifyService.showError('کد امنیتی را وارد کنید');

    }

    try {

      this.otherService.Showspinner();

      const resp = await axios.post('Login4Radyab', this.otherService.stringNumberToNumber(model));

      // اگر کاربر سوپر یوزر بود

      if (resp.data.bSuperUser) {

        localStorage.setItem('5B6Wjog=', this.gurdService.encrypt(resp.data.strUserName));

        localStorage.setItem('VkX1/o5p', this.gurdService.encrypt(model.strPassword));

        return this.router.navigateByUrl("/settings/security-options")

      }

      // اگر کاربر معمولی بود

      if (resp.data.Result == -6) {

        this.notifyService.showError(resp.data.Message);

        this.LoginModel.controls['strCaptcha'].setValue('');

        this.get_Captcha();

      }

      // اگر خطایی رخ داد

      if (resp.data.Result == 2) {

        this.notifyService.showError(resp.data.Message);

        this.get_Captcha();

        if (this.isMobile) {

          this.router.navigate([`register`], { queryParams: { otp: model.strUserName } });

        }

        else {

          this.signUp();

          this.OtpModel.controls["strUserName"].setValue(model.strUserName);

          this.otp = true;

          this.startTimer();
        }

        return;
      }

      // اگر درخواست موفقیت آمیز بود

      if (resp.data.Result == 1) {

        var model2 = {

          iSystemUser: resp.data.Id,

          strSession: resp.data.strSession,

        }

        const resp2 = await axios.post("GetRadyabUserAbility2", model2) as any;

        if (resp.data.ISSessionExpired == true && this.timesLoginBtnClicked > 2) {

          this.notifyService.showError('مجددا وارد سامانه شوید')

          this.otherService.removeLocalStorage();

          // this.router.navigate(['login']);

          this.router.navigate(['login'], { queryParams: { error: '103' } });


          return;

        }

        resp2.data = JSON.parse(resp2.data);

        localStorage.setItem('Session', this.gurdService.encrypt(resp.data.strSession));

        localStorage.setItem('ID', this.gurdService.encrypt(resp.data.Id.toString()));

        localStorage.setItem('_Session', resp.data.strSession);

        localStorage.setItem('_ID', resp.data.Id.toString());

        localStorage.setItem('companyName', this.gurdService.encrypt(resp.data.strCompanyName));

        localStorage.setItem('FullName', this.gurdService.encrypt(resp.data.strFullName));

        localStorage.setItem('UnitID', this.gurdService.encrypt(resp.data.strUnitID));

        localStorage.setItem('UserName', this.gurdService.encrypt(resp.data.strUserName));

        localStorage.setItem('pass', this.gurdService.encrypt(model.strPassword));
        // localStorage.setItem('pass', this.gurdService.encrypt(resp.data.strPassword));

        var city = {

          cityCode: resp.data.strCityCode,

          cityName: resp.data.strCityName

        };

        localStorage.setItem('cityCode', this.gurdService.encrypt(JSON.stringify(city)));

        var acsess = {

          bEnableAddCar: resp.data?.bEnableAddCar,

          bEnableSOS: resp.data?.bEnableSOS,

          bEnableIntroducedMobile: resp.data?.bEnableIntroducedMobile,

          bEnableEditCar: resp.data?.bEnableEditCar,

          bEnableDashboard: resp.data?.bEnableDashboard,

          bEnableAddID: resp.data?.bEnableAddID,

          bEnableGeoFance: resp.data?.bEnableGeoFance,

          bEnableCommand: resp.data?.bEnableCommand,

          bEnableCarRvenues: resp.data?.bEnableCarRvenues,

          bEnableTiket: resp.data?.bEnableTiket,

          bSupport: resp.data?.bSupport,

          bShop: resp.data?.bShop,

        } as any;

        for (let index = 0; index < resp2.data.length; index++) {

          acsess[resp2.data[index].strXenotakAbility] = resp2.data[index].bHas == 0 ? false : true;

        }

        // دسترسی های اتوماسیون سفر

        if (acsess.bPeysepar) {

          var peysepar_Access: any = {}

          let res = JSON.parse((await axios.post("Peysepar_GetOrganizationAbility", model2)).data);

          for (let index = 0; index < res.length; index++) {

            peysepar_Access[res[index].strSystemAbility] = res[index].bHas == 0 ? false : true;

          }

        }

        localStorage.setItem("menu", this.gurdService.encrypt(JSON.stringify({ ...acsess, ...peysepar_Access })));

        if (window.localStorage.getItem("version") != model.strWebAppVersion) {

          localStorage.setItem('version', model.strWebAppVersion || '');

          window.location.href = window.location.href;

        }

        else {

          localStorage.setItem('version', model.strWebAppVersion);

        }

        this.router.navigate(resp.data.bChangePassword ? ['/update-password'] : ['']);

      }

      // اگر خطایی رخ داد

      else {

        this.notifyService.showError(resp.data.Message);

        this.get_Captcha();

        return;
      }

    }

    catch (err) {

      this.notifyService.showError("خطایی رخ داده است");

    }

    finally {

      this.otherService.nonespinner();

    }

  };

  ForgetPass = async () => {

    var model = { strUserName: this.LoginModel.controls['strUserName'].value };

    if (model.strUserName == null || model.strUserName == '') {

      return this.notifyService.showError('لطفا نام کاربری خود را وارد کنید');

    }

    const resp = await axios.post('ForgotRadyabPassword', model);

    if (resp.data.Result != 1) return this.notifyService.showError(resp.data.Message);

    if (resp.data.Result == 1) this.notifyService.showSuccess('رمز عبور تا لحظاتی دیگر برای شما پیامک خواهد شد');

  };

  getLink(type: number) {
    this.otherService.getLink(type);
  }

  signUp() {
    const container = document.getElementById('myContainer') as any;
    container.classList.add("right-panel-active");
  }

  signIn() {
    const container = document.getElementById('myContainer') as any;
    container.classList.remove("right-panel-active");

  }

  register = async () => {
    var model = this.RegisterModel.value;
    if (model.strUserName.length != 11) {
      this.notifyService.showError('شماره وارد شده معتبر نیست');
      return;
    }
    if (model.strFullName == null || model.strFullName == '') {
      this.notifyService.showError('لطفا نام کامل خود را وارد کنید');
      return;
    }
    if (model.strPassword == null || model.strPassword == '') {
      this.notifyService.showError('لطفا رمز عبور را  وارد کنید');
      return;
    }
    if (model.strPassword != model.strPassword2) {
      this.notifyService.showError('رمز های وارد شده برابر نمی باشند');
      return;
    } else {
      this.otherService.Showspinner();
      const resp = await axios.post('RegisterRadyabUser', model);
      this.otherService.nonespinner();
      if (resp.data.Result != 1) {
        this.notifyService.showError(resp.data.Message);
        return;
      } else {
        this.otp = true;
        this.startTimer();
      }
    }

  };

  chekOtp = async () => {
    var model = this.OtpModel.value;

    model.strUserName = this.RegisterModel.controls['strUserName'].value ? this.RegisterModel.controls['strUserName'].value : model.strUserName;
    if (model.iOTP == null || model.otp == '') {
      this.notifyService.showError('لطفا کد دریافتی را وارد کنید');
      return;
    }
    const resp = await axios.post('CheckRegisterRadyabOTP', model);
    if (resp.data.Result != 1) {
      this.notifyService.showError(resp.data.Message);
      return;
    }
    if (resp.data.Result == 1) {
      // localStorage.setItem('Session', resp.data.strSession);
      localStorage.setItem('Session', this.gurdService.encrypt(resp.data.strSession));
      // localStorage.setItem('ID', resp.data.Id);
      localStorage.setItem('ID', this.gurdService.encrypt(resp.data.Id));
      // localStorage.setItem('companyName', resp.data.strCompanyName);
      localStorage.setItem('companyName', this.gurdService.encrypt(resp.data.strCompanyName));
      // localStorage.setItem('FullName', resp.data.strFullName);
      localStorage.setItem('FullName', this.gurdService.encrypt(resp.data.strFullName));
      // localStorage.setItem('UnitID', resp.data.strUnitID);
      localStorage.setItem('UnitID', this.gurdService.encrypt(resp.data.strUnitID));

      var model2 = {
        iSystemUser: resp.data.Id, strSession: resp.data.strSession,
      }
      const resp2 = await axios.post("GetRadyabUserAbility2", model2) as any;

      if (resp.data.ISSessionExpired == true) {

        this.otherService.removeLocalStorage();

        // this.router.navigate(['login']);

        this.router.navigate(['login'], { queryParams: { error: '104' } });


        return;

      }
      resp2.data = JSON.parse(resp2.data);
      var acsess = {
        bEnableAddCar: resp.data.bEnableAddCar,
        bEnableSOS: resp.data.bEnableSOS,
        bEnableIntroducedMobile: resp.data.bEnableIntroducedMobile,
        bSupport: resp.data.bSupport,
        bEnableEditCar: resp.data.bEnableEditCar,
        bEnableDashboard: resp.data.bEnableDashboard,
        bEnableAddID: resp.data.bEnableAddID,
        bEnableGeoFance: resp.data.bEnableGeoFance,
        bEnableCommand: resp.data.bEnableCommand,
        bEnableCarRvenues: resp.data.bEnableCarRvenues,
        bEnableTiket: resp.data.bEnableTiket,
        bShop: resp.data.bShop,
      } as any;
      for (let index = 0; index < resp2.data.length; index++) {

        acsess[resp2.data[index].strXenotakAbility] = resp2.data[index].bHas == 0 ? false : true
      }
      // localStorage.setItem("menu", JSON.stringify(acsess));
      localStorage.setItem("menu", this.gurdService.encrypt(JSON.stringify(acsess)));

      var city = { cityCode: resp.data.strCityCode, cityName: resp.data.strCityName, }

      // localStorage.setItem('cityCode', JSON.stringify(city));
      localStorage.setItem('cityCode', this.gurdService.encrypt(JSON.stringify(city)));

      localStorage.setItem('UserName', this.gurdService.encrypt(this.RegisterModel.controls['strUserName'].value));
      localStorage.setItem('pass', this.gurdService.encrypt(this.RegisterModel.controls['strPassword'].value));
      this.router.navigate(['/']);
    }
  };

  createOtp = async (sendAgain?: any) => {
    var model = {
      strUserName: this.RegisterModel.controls['strUserName'].value
    };
    const resp = await axios.post('CreateOTP4Radyab', model);
    if (resp.data.iResult == 1) {
      if (sendAgain) {
        this.notifyService.showSuccess('کد تایید مجددا پیامک شد ');

      }
      else {
        this.notifyService.showSuccess('با موفیقت ارسال شد');

      }
      this.repet = !this.repet;
      this.startTimer();
    }
    if (resp.data.Result != 1) {
      this.notifyService.showError(resp.data.Message);
      return;
    }
  };

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.timeLeft = 120;
        this.pauseTimer();
        this.repet = !this.repet;
      }
    }, 1000);
  }

  pauseTimer() {
    clearInterval(this.interval);
  }

  numberOnly(event: any): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57)) {

      return false;

    }

    return true;
  }

  generateRandomNumber(min: any, max: any) {

    // this.captcha = this.generateRandomNumber(1111, 9999)

    return Math.floor((Math.random() * (max - min + 1) + min));

  }

  subString_Title(text: string, limit?: number) {
    if (limit && text?.length > limit) text = text.slice(0, limit) + '...';

    if (!limit && text?.length > 55) text = text.slice(0, 55) + '...';

    return text;
  }

  getAds = async () => {

    this.otherService.Showspinner();

    const resp = await axios.post('Taxilon_Advertisement_Public_List_New', {});

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data.toString());

    this.lst_NewAds = res;

  }

  getEvents = async () => {

    this.otherService.Showspinner();

    const resp = await axios.post(`TaxilLon_News_List?iPage=${-2}`, {});

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data.toString());

    this.news = res;

  }

  getEducations = async () => {

    this.otherService.Showspinner();

    const resp = await axios.post(`EducationalContent_List`, {});

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data.toString());

    res.forEach((el: any, index: number) => {

      res[index].strContentPath = this.return_SafeUrl(el.strContentPath);

    })

    this.lst_Educations = res;


  }

  return_SafeUrl(url: string) {

    return this.sanitizer.bypassSecurityTrustResourceUrl(url);

  }

  showAds(item: any) {

    window.open(`/job/${this.convertSpaceTo_(item.strTitle, '-')}/${item.iTaxilon_Advertisement}`, '_blank')

  }

  convertSpaceTo_(strTitle: string, symbol?: string): string {

    return strTitle.trim().replace(/[\s\/\-*]+|or/g, symbol ? symbol : "_");


  }

  openEducation(item) {

    window.open(`/education/${item.iEducationalContent}`, '_blank')

  }

  openNews(iNews: number) {

    window.open(`/news/${iNews}`, '_blank');

  }


}
